import { z } from "zod";

import { zFeatureSchema } from "./feature";

import { ImageEntity } from "~/entities/image/@x/service";
import { ServiceCategoryEntity } from "~/entities/service-category/@x/service";

const zPossiblyEmptyName = z
  .string()
  .trim()
  .max(2 ** 6);

const zSchema = z.object({
  id: z.string().uuid(),
  name: zPossiblyEmptyName.nonempty(),
  description: z
    .string()
    .trim()
    .max(2 ** 9),
  price: z.number().positive(),
  imageId: ImageEntity.zSchema.shape.id.nullable(),
  isActive: z.boolean(),
  category: ServiceCategoryEntity.zSchema,
  features: z.array(zFeatureSchema),
});
type Schema = z.infer<typeof zSchema>;

export { zPossiblyEmptyName, zSchema };
export type { Schema };
